import type { FaireProductEntity } from "../../entity_types/product";

export const p_pf8zfzuzpr: FaireProductEntity = {
  token: "p_pf8zfzuzpr",
  type: "product",
  name: "Mom Florals Mother's Day Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/f296dca4aad38f495a31a7f34d4ceb0bfa91ffbf2ac89240b7b6ef94d6063cfd.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Celebrate the love and beauty of motherhood with our "Mom Florals" Mother\'s Day Greeting Card. Delicately crafted with a touch of elegance, this card is the perfect way to express your gratitude and appreciation for everything Mom does. Featuring a stunning floral design in soft pastel hues, this card captures the timeless essence of maternal love. Whether you\'re near or far, sending this heartfelt card will let Mom know just how much she means to you on her special day. \n\n•Size: 5.5" x 4.25" card\n•Features: Blank interior and coordinating envelope\n•Sentiment: Mom',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:02.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
